import { AVATAR_COLORS } from 'src/constants/global'

import './AvatarPlaceholder.css'

interface AvatarPlaceholderProps {
  text: string
  className?: string
}

function getColor(str: string): string {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return AVATAR_COLORS[Math.abs(hash % AVATAR_COLORS.length)]
}

export default function AvatarPlaceholder({
  text,
  className = ''
}: AvatarPlaceholderProps) {
  const seed = text || '?'
  const color = getColor(seed)
  const displayChar = seed[0].toUpperCase()

  return (
    <div
      className={`avatar-placeholder ${className}`}
      style={{
        background: `linear-gradient(to bottom, ${color}44 , ${color}11 60%)`,
        color
      }}
    >
      <span>{displayChar}</span>
    </div>
  )
}
